import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var PayStatus = {
  0: "待付款",
  1: "已付款"
};
export default {
  data: function data() {
    return {
      list: {
        data: [],
        pagination: {
          total: 0,
          perPage: 10,
          current: 1,
          rangeAfter: 2,
          rangeBefore: 2
        }
      }
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var params, status;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            params = _this.$route.params;
            status = params.status;
            _this.status = status;
            _context.next = 5;
            return _this.initListData();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  filters: {
    payStatusFilter: function payStatusFilter(status) {
      return PayStatus[status];
    }
  },
  methods: {
    pullListData: function pullListData() {
      return this.$getHttpClient().post("/pjyy-deepexi-order-center/api/v1/bill/myBill", {
        page: this.list.pagination.current,
        pageSize: this.list.pagination.perPage
      }).then(function (responses) {
        var data = responses.data;
        if (data.code === "200") {
          return data.data;
        }
        return;
      });
    },
    initListData: function initListData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.pullListData();
            case 2:
              result = _context2.sent;
              console.log(result);
              if (result) {
                _this2.list.pagination.total = result.totalElements;
                _this2.list.data = result.content;
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    listPaginationChangeHandler: function listPaginationChangeHandler(current) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.list.pagination.current = current;
              _context3.next = 3;
              return _this3.initListData();
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }
};